















































import _ from 'lodash';
import {
  computed,
  defineComponent,
  ref,
  toRefs,
  watch,
  getCurrentInstance,
  ComponentInternalInstance,
  nextTick,
} from '@vue/composition-api';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    fromName: {
      required: true,
      type: String,
      default: '',
    },
    type: {
      required: true,
      type: String,
      default: '',
    },
    renameError: {
      required: true,
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { fileNameMaxLength: folderNameMaxLength } = ConstantConfig;
    const innerType = computed({
      get() {
        return props.type;
      },
      set(val) {
        context.emit('update:type', val);
      },
    });
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const { fromName, renameError } = toRefs(props);
    const innerName = ref('');
    const innerError = ref('');
    watch(
      () => props.show,
      () => {
        if (props.show) {
          innerName.value = fromName.value;
        }
      },
    );
    watch(renameError, () => {
      renameError.value && (innerError.value = renameError.value);
      context.emit('errReset');
    });
    const validateName = (innerName: string) => {
      if (innerName.indexOf('/') !== -1) {
        innerError.value = i18n_t('名称不支持字符“/”');
      } else if (innerName === '') {
        innerError.value = i18n_t('名称不能为空');
      } else {
        innerError.value = '';
        context.emit('errReset');
      }
    };
    const throttleValidate = _.throttle(validateName, 500);
    const force = ref(true);
    const methods = {
      submit() {
        if (innerError.value !== '' || innerName.value.trim() === '') return;
        context.emit('onSubmit', {
          name: innerName.value.trim(),
          force: force.value ? 'overwrite' : 'ask',
        });
      },
      reset() {
        innerName.value = fromName.value;
      },
      checkChange() {
        if (innerError.value === i18n_t('存在同名文件（夹），请更换名称')) {
          innerError.value = '';
        }
      },
    };
    watch(innerShow, val => {
      if (!val) {
        innerError.value = '';
      } else {
        nextTick(() => {
          const { renameInput }: any = (currComponent as ComponentInternalInstance).refs;
          const inputDom = renameInput?.$el.children[0]?.children[0] as HTMLInputElement;
          if (inputDom) {
            // 现在的策略是选中后缀的前面全部内容，没有后缀则全选
            const inputVal = inputDom.value;
            const lastDotIndex = inputVal.lastIndexOf('.');
            inputDom.focus();
            inputDom.setSelectionRange(0, lastDotIndex);
          }
        });
      }
    });
    return {
      innerShow,
      innerName,
      force,
      innerType,
      innerError,
      validateName,
      throttleValidate,
      folderNameMaxLength,
      ...methods,
    };
  },
});
